
import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { Switch, Route } from 'react-router-dom';
import axios from "axios";
import Sidebar from "./Sidebar";
import MainContent from "./MainContent";
import YoureModule from "./YourModule";
import Navbar from "../Sidebar/Navbar";
import SidebarContainer from "../Sidebar/SidebarContainer";
import IntentsAns from "../Pages/IntentsAns";
import IntentList from "../Pages/IntentList";
import UpdateIntents from "../Pages/UpdateIntents";
import ProfilePg from "../Pages/ProfilePg";
import AddCases from "../Pages/PatientInfo/AddPatient";
import LAddCases from "../Pages/PatientInfo/LAddPatient";
import CaseList from "../Pages/PatientInfo/PatientList";
import LCaseList from "../Pages/PatientInfo/LPatientList";
import UpdatePatient from "../Pages/PatientInfo/Update_Patient";
import LUpdatePatient from "../Pages/PatientInfo/LUpdate_Patient";
import CaseManagement from "../Pages/PatientInfo/CaseManagement";
import AddScenario from "../Pages/Scenario/AddScenario";
import AddManagerScenario from "../Pages/Scenario/AddManagerScenario";
import ScenarioList from "../Pages/Scenario/ScenarioList";
import UpdateScenario from "../Pages/Scenario/UpdateScenario";
import PatientQues from "../Pages/PatientInfo/PatientQues";
import PtientIntentList from "../Pages/PatientInfo/Ptient_Intent_List";
import MasterIntent from "../Pages/MasterIntent/Master_Intent";
import MasterIntentList from "../Pages/MasterIntent/Master_IntentList";
import UpdateMasterIntent from "../Pages/MasterIntent/Update_Master_Intent";
import AddManager from "../Pages/ManagerInfo/AddManager";
import ManagerList from "../Pages/ManagerInfo/ManagerList";
import UpdateManager from "../Pages/ManagerInfo/UpdateManager";
import AppUserList from "../Pages/AppUserManagement/AppUserList";
import AddAppUser from "../Pages/AppUserManagement/AddAppUser";
import EditAppUser from "../Pages/AppUserManagement/EditAppUser";
import ManagerNavbar from "../Pages/ManagerInfo/ManagerNavbar";
import ManagerSidebarContainer from "../Pages/ManagerInfo/ManagerSidebarContainer";
import MnagerMainContent from "../Pages/ManagerInfo/MnagerMainContent";
import AddManagerPatient from "../Pages/ManagerInfo/ManagerPatient/AddManagerPatient";
import LAddManagerPatient from "../Pages/ManagerInfo/ManagerPatient/LAddManagerPatient";
import ManagerPatientList from "../Pages/ManagerInfo/ManagerPatient/ManagerPatientList";
import LManagerPatientList from "../Pages/ManagerInfo/ManagerPatient/LManagerPatientList";
import PatientUpdateIntents from "../Pages/PatientInfo/Patient_UpdateIntents";
import PtientCusIntentList from "../Pages/PatientInfo/Ptient_Custom_Intent_List"
import ChatGptList from "../Pages/ChatGptInfo/ChatGptList";
import ChatGptScenarioList from "../Pages/ChatGptInfo/ChatGptScenarioList";
import DeberiefingList from "../Pages/DeberiefingInfo/DeberiefingList";
import ScenarioDeberiefingList from "../Pages/DeberiefingInfo/ScenarioDeberiefingList";
import AddPortal from "../Pages/PortalInfo/AddPortal";
import PortalList from "../Pages/PortalInfo/PortalList";
import UpdatePortal from "../Pages/PortalInfo/UpdatePortal";
import ManIntentAns from "../Pages/ManagerInfo/ManagerIntent/ManIntentAns";
import ManIntentList from "../Pages/ManagerInfo/ManagerIntent/ManIntentList";
import UpdateManIntents from "../Pages/ManagerInfo/ManagerIntent/Update_ManIntents";
import CategoryList from "../Pages/CategoryInfo/Category_List";
import UpdateCategory from "../Pages/CategoryInfo/UpdateCategory";
import PortalMasterIntentList from "../Pages/PortalInfo/PortalMaster_IntentList";
import ManMasterIntent from "../Pages/ManagerInfo/ManMasterIntent/ManMasterIntent";
import ManMasterIntentList from "../Pages/ManagerInfo/ManMasterIntent/ManMasterIntentList";
import UpdateManMasterIntent from "../Pages/ManagerInfo/ManMasterIntent/Update_Man_Master_Intent";
import TwstGpList from "../Pages/ChatGptInfo/TwstGpList";
import imagelogo from '../../images/aiHumansLogo.jpg'
import AddEnvironment from "../Pages/Environment/AddEnvironment";
import EnvironmentList from "../Pages/Environment/EnvironmentList";
import UpdateEnvironment from "../Pages/Environment/UpdateEnvironment";
import AddCharacter from "../Pages/Character/AddCharacter";
import AddAnimator from "../Pages/Animator/AddAnimator";
import CharacterList from "../Pages/Character/CharacterList";
import AnimatorList from "../Pages/Animator/AnimatorList";
import UpdateCharacter from "../Pages/Character/UpdateCharacter";
import UpdateAnimator from "../Pages/Animator/UpdateAnimator";
import AddScenarioEnvironment from "../Pages/Environment/AddScenarioEnvironment";
import ScenarioEnvironmentList from "../Pages/Environment/ScenarioEnvironmentList";
import ScenarioUpdateEnvironment from "../Pages/Environment/ScenarioUpdateEnvironment";

import AddVoice from "../Pages/Voice/AddVoice";
import VoiceList from "../Pages/Voice/VoiceList";
import UpdateVoice from "../Pages/Voice/UpdateVoice";

import TTSLog from "../Pages/Elevenlabs/TTSLog";
import PortalCharStats from "../Pages/PortalCharStats/PortalCharStats";

import UserNavbar from "../Pages/UserDashboard/UserNavbar";
import UserMyCases from "../Pages/UserDashboard/UserMyCases";
import UserSidebarContainer from "../Pages/UserDashboard/UserSidebarContainer";
import UserMainContent from "../Pages/UserDashboard/UserMainContent";
import UserUsageGraph from "../Pages/UserDashboard/UserUsageGraph";
import UserChatHistory from "../Pages/UserDashboard/UserChatHistory";
import UserChangePassword from "../Pages/UserDashboard/UserChangePassword";



function Home() {
  const [user, setuser] = useState(localStorage.getItem('URole'))
  const mangerId = localStorage.getItem('ManegerId');

  const dispatch = useDispatch();

  // const [colr, setcolr] = useState('')
  const [Colr1, setColr1] = useState('')
  const [ShowLegacyCases, setShowLegacyCases] = useState(true)
  const [Colr2, setColr2] = useState('')
  const [Colr3, setColr3] = useState('')

  const imagepath = `${process.env.REACT_APP_API_URL}/GetPortalImageByUserId?MangId=` + mangerId;

  useEffect(() => {
    // dispatch(getAllPosts());
    mangerId == 1 ? LoadPortalFalse() : LoadPortals();
  }, []);

  const LoadPortalFalse = () => {

  }

  const LoadPortals = () => {
    const datavalue = {
      UsrId: mangerId
    }

    var authOptions = {
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/getPortalByUserId`,
      data: datavalue,
      headers: { 'Content-Type': 'multipart/form-data' },
    };
    axios(authOptions)
      .then(res => {
        setColr1(res.data[0].sidebar_Color)
        setShowLegacyCases(res.data[0].show_Legacy_Cases)
        setColr2(res.data[0].brand_Color)
        setColr3(res.data[0].header_Color)
      })
  }

  const handleLogout = () => {
    localStorage.clear();
    window.location.pathname = "/signin";
  };
  return (
    <div>
      {/* <h1>This is a React-Redux Structure Demo App</h1>
      <h2>Welcome to the Homepage / Landing page</h2>
      <button className="btn btn-primary" onClick={handleLogout}>
        Logout
      </button>
      <Users /> */}
      <section className="main-wrap">
        <div className="container-fluid p-0">
          {
            user === 'AppUser' ?
              <div className="page-wrapper">
                <div className="page-header navbar navbar-fixed-top" style={{ backgroundColor: "#ffc63e" }}>
                  <div className="page-header-inner ">
                    <div className="page-logo">
                      <a href="index">
                        <span className="logo-default"><img style={{ width: "200px", maxHeight: "50px", objectFit: "contain" }} src={imagelogo} alt="" /></span>
                      </a>
                    </div>
                    <UserNavbar />
                  </div>
                </div>
                <div className="page-container">
                  <UserSidebarContainer />
                  <Switch>
                    <Route exact path='/' component={UserMainContent} />
                    <Route exact path='/index' component={UserMainContent} />
                    <Route path='/UserMyCases' component={UserMyCases} />
                    <Route path='/UserUsageGraph' component={UserUsageGraph} />
                    <Route path='/UserChatHistory' component={UserChatHistory} />
                    <Route path='/UserChangePassword' component={UserChangePassword} />
                  </Switch>
                </div>
              </div> :
              user === 'Admin' ?
                <div className="page-wrapper">
                  <div className="page-header navbar navbar-fixed-top" style={{ backgroundColor: "#ffc63e" }}>
                    <div className="page-header-inner ">

                      <div className="page-logo">
                        <a href="index">
                          {/* <span className="logo-icon fa fa-stethoscope fa-rotate-45"></span> */}
                          {/* <span className="logo-default">PATIENT.AI</span>  */}
                          <span className="logo-default"><img style={{ width: "200px", maxHeight: "50px", objectFit: "contain" }} src={imagelogo} alt="" /></span>
                        </a>
                      </div>

                      <Navbar />
                      {/* <SettingSidebar /> */}
                    </div>
                  </div>
                  <div className="page-container">
                    <SidebarContainer />
                    <Switch>
                      <Route exact path='/' component={MainContent} />
                      <Route exact path='/index' component={MainContent} />
                      <Route path='/IntentAns' component={IntentsAns} />
                      <Route path='/IntentList' component={IntentList} />
                      <Route path='/UpdateIntents' component={UpdateIntents} />
                      <Route path='/Profile' component={ProfilePg} />
                      <Route path='/AddCases' component={AddCases} />
                      <Route path='/LAddCases' component={LAddCases} />
                      <Route path='/CaseList' component={CaseList} />
                      <Route path='/LCaseList' component={LCaseList} />
                      <Route path='/UpdatePatient' component={UpdatePatient} />
                      <Route path='/LUpdatePatient' component={LUpdatePatient} />
                      <Route path='/CaseManagement' component={CaseManagement} />
                      <Route path='/PatientQues' component={PatientQues} />
                      <Route path='/PtientIntentList' component={PtientIntentList} />
                      <Route path='/PtientCusIntentList' component={PtientCusIntentList} />
                      {/* PtientCusIntentList */}
                      {/* <Route path='/PtientIntentList/:value' component={PtientIntentList} /> */}
                      <Route path='/MasterIntent' component={MasterIntent} />
                      <Route path='/MasterIntentList' component={MasterIntentList} />
                      <Route path='/UpdateMasterIntent' component={UpdateMasterIntent} />
                      <Route path='/AddManager' component={AddManager} />
                      <Route path='/ManagerList' component={ManagerList} />
                      <Route path='/UpdateManager' component={UpdateManager} />
                      <Route path='/AppUserList' component={AppUserList} />
                      <Route path='/AddAppUser' component={AddAppUser} />
                      <Route path='/EditAppUser' component={EditAppUser} />
                      <Route path='/PatientUpdateIntents' component={PatientUpdateIntents} />
                      <Route path='/ChatGptList' component={ChatGptList} />
                      <Route path='/ChatGptScenarioList' component={ChatGptScenarioList} />
                      <Route path='/DeberiefingList' component={DeberiefingList} />
                      <Route path='/ScenarioDeberiefingList' component={ScenarioDeberiefingList} />
                      <Route path='/AddPortal' component={AddPortal} />
                      <Route path='/PortalList' component={PortalList} />
                      <Route path='/AddScenario' component={AddScenario} />
                      <Route path='/ScenarioList' component={ScenarioList} />
                      <Route path='/UpdateScenario' component={UpdateScenario} />
                      <Route path='/UpdatePortal' component={UpdatePortal} />
                      <Route path='/CategoryList' component={CategoryList} />
                      <Route path='/UpdateCategory' component={UpdateCategory} />
                      <Route path='/PortalMasterIntentList' component={PortalMasterIntentList} />
                      <Route path='/AddEnvironment' component={AddEnvironment} />
                      <Route path='/EnvironmentList' component={EnvironmentList} />
                      <Route path='/UpdateEnvironment' component={UpdateEnvironment} />
                      <Route path='/AddCharacter' component={AddCharacter} />
                      <Route path='/CharacterList' component={CharacterList} />
                      <Route path='/AddAnimator' component={AddAnimator} />
                      <Route path='/AnimatorList' component={AnimatorList} />
                      <Route path='/UpdateCharacter' component={UpdateCharacter} />
                      <Route path='/UpdateAnimator' component={UpdateAnimator} />
                      <Route path='/AddScenarioEnvironment' component={AddScenarioEnvironment} />
                      <Route path='/ScenarioEnvironmentList' component={ScenarioEnvironmentList} />
                      <Route path='/ScenarioUpdateEnvironment' component={ScenarioUpdateEnvironment} />

                      <Route path='/AddVoice' component={AddVoice} />
                      <Route path='/VoiceList' component={VoiceList} />
                      <Route path='/UpdateVoice' component={UpdateVoice} />

                      <Route path='/TTSLog' component={TTSLog} />
                      <Route path='/PortalCharStats' component={PortalCharStats} />

                      {/* <Route path='/TwstGpList' component={TwstGpList} /> */}
                      {/* <Route path='/ChatGptList' component={Chatgp} /> */}

                    </Switch>
                  </div>
                </div> :
                <div className="page-wrapper">
                  <div className="page-header navbar navbar-fixed-top" style={{ "background-color": Colr3 }}>
                    <div className="page-header-inner ">

                      {/* <div className="page-logo bg-white"> */}
                      <div className="page-logo" style={{ "background-color": Colr2 }}>
                        <a href="index">
                          {/* <span className="logo-icon fa fa-stethoscope fa-rotate-45"></span>
                      <span className="logo-default">PATIENT.AI</span>  */}
                          <span className="logo-default"><img style={{ width: "200px", maxHeight: "50px", objectFit: "contain" }} src={imagepath} alt="" /></span>
                        </a>
                      </div>
                      <ManagerNavbar />
                    </div>
                  </div>
                  <div className="page-container">
                    <ManagerSidebarContainer data={Colr1} showLegacyCases={ShowLegacyCases} />
                    <Switch>
                      <Route exact path='/' component={MnagerMainContent} />
                      <Route exact path='/index' component={MnagerMainContent} />
                      <Route path='/UpdateManager' component={UpdateManager} />
                      <Route path='/AddManagerPatient' component={AddManagerPatient} />
                      <Route path='/LAddManagerPatient' component={LAddManagerPatient} />
                      <Route path='/ManagerPatientList' component={ManagerPatientList} />
                      <Route path='/LManagerPatientList' component={LManagerPatientList} />
                      <Route path='/UpdatePatient' component={UpdatePatient} />
                      <Route path='/LUpdatePatient' component={LUpdatePatient} />
                      <Route path='/PatientQues' component={PatientQues} />
                      <Route path='/PtientIntentList' component={PtientIntentList} />
                      <Route path='/PtientCusIntentList' component={PtientCusIntentList} />
                      <Route path='/PatientUpdateIntents' component={PatientUpdateIntents} />
                      <Route path='/ManIntentAns' component={ManIntentAns} />
                      <Route path='/ManIntentList' component={ManIntentList} />
                      <Route path='/UpdateManIntents' component={UpdateManIntents} />
                      <Route path='/ManMasterIntent' component={ManMasterIntent} />
                      <Route path='/ManMasterIntentList' component={ManMasterIntentList} />
                      <Route path='/Update_MasterIntent' component={UpdateManMasterIntent} />
                      <Route path='/ChatGptList' component={ChatGptList} />
                      <Route path='/ChatGptScenarioList' component={ChatGptScenarioList} />
                      <Route path='/DeberiefingList' component={DeberiefingList} />
                      <Route path='/ScenarioDeberiefingList' component={ScenarioDeberiefingList} />
                      <Route path='/AddManagerScenario' component={AddManagerScenario} />
                      <Route path='/ScenarioList' component={ScenarioList} />
                      <Route path='/UpdateScenario' component={UpdateScenario} />
                      <Route path='/PortalCharStats' component={PortalCharStats} />

                    </Switch>
                  </div>
                </div>
          }


        </div>
      </section>
    </div>

  );
}

export default Home;
